import { Formik } from 'formik';
import { StepContentSwitch } from 'modules/cv-builder';
import { CvSubmittedScreen } from './components/CvSubmittedScreen';
import { useCvBuilderData } from './data/CvBuilderDataContext';
import { validateCVForm } from './utils';

/**
 * Pure wizard shell: it gets seed values from the active CvBuilderData provider
 * (authenticated or guest) and renders nothing until they have loaded. All
 * persistence/submit goes through the data port — no Auth0 / IndexedDB knowledge here.
 */
export const CVBuilder = () => {
  const { initialValues, submitted } = useCvBuilderData();

  // Terminal state (authenticated flow): the CV is in, swap to the confirmation
  // screen so it can't be edited or re-submitted. The guest flow keeps `submitted`
  // false and renders its own page-level terminal instead.
  if (submitted) return <CvSubmittedScreen />;

  if (!initialValues) return null;

  return (
    <Formik
      validate={validateCVForm}
      enableReinitialize
      initialValues={initialValues}
      onSubmit={() => {}} // submission handled inside Summary via the data port
    >
      <StepContentSwitch />
    </Formik>
  );
};
